/** Settings → Agents → one agent's editor. */
export default {
  builtinNotice:
    "Denker is the system orchestrator. You can change the model and runtime; other settings are managed by the system and shown for reference.",
  sectionIdentity: "Identity",
  changeAvatar: "Change avatar",
  shuffle: "Shuffle",
  name: "Name",
  role: "Role",
  roleHint: "Short description shown in agent lists",
  rolePlaceholder: "e.g. Senior software engineer",
  capabilities: "Capabilities",
  capabilitiesHint: "What this agent is good at — shown in agent picker",
  capabilitiesPlaceholder: "Describe what this agent can do…",
  systemPrompt: "System prompt",
  systemPromptHint: "Defining persona and behavior",
  sectionModelRuntime: "Model & Runtime",
  runtime: "Runtime",
  runtimeHint: "Which CLI powers this agent",
  runtimeSelection: "Runtime selection",
  runtimeConnectRunner: "{runtime} — connect Agent Runner",
  runtimeNotDetected: "{runtime} — not detected",
  runtimeBundled: "{runtime} — built-in runtime bundled with Denker",
  builtIn: "Built-in",
  model: "Model",
  modelFree: "Free",
  thinkingEffort: "Thinking effort",
  thinkingEffortHint: "How much the model reasons before responding",
  effortDefault: "Default",
  effortMinimal: "Minimal",
  effortLow: "Low",
  effortMedium: "Medium",
  effortHigh: "High",
  effortXhigh: "Extra High",
  effortMax: "Max",
  effortUltra: "Ultra",
  maxTurns: "Max turns per run",
  maxTurnsHint: "Maximum conversation turns before the agent stops",
  sectionConnectedApps: "Connected Apps",
  integrationsUpgrading: "Integrations are being upgraded",
  sectionSkills: "Skills",
  skillsDescription: "Skills define reusable behaviors and protocols",
  removeSkill: "Remove {name}",
  noSkills: "No skills assigned.",
  browseSkillCatalog: "Browse Skill Catalog",
  sectionRunPolicy: "Run Policy",
  heartbeatOnInterval: "Heartbeat on interval",
  heartbeatDescription: "Agent wakes up periodically to check for work",
  heartbeatEvery: "Run heartbeat every",
  secondsShort: "sec",
  enabled: "Enabled",
  suspendedAfter: "Suspended after {cap} runs/24h",
  resume: "Resume",
  resuming: "Resuming…",
  saving: "Saving…",
  deleteTitle: "Delete agent",
  deleteDescription:
    'Permanently delete agent "{name}"? This cannot be undone.',
} as const;
